import { QUOTATION_WORKFLOW_STATUS_LABEL } from '../quotationWorkflow';

/** Status untuk filter daftar (workflow + legacy). */
export const QUOTATION_STATUS_OPTIONS = [
  { value: 'draft', label: QUOTATION_WORKFLOW_STATUS_LABEL.draft },
  { value: 'submitted', label: QUOTATION_WORKFLOW_STATUS_LABEL.submitted },
  { value: 'approved', label: QUOTATION_WORKFLOW_STATUS_LABEL.approved },
  { value: 'need_manajer_approval', label: QUOTATION_WORKFLOW_STATUS_LABEL.need_manajer_approval },
  { value: 'manajer_approved', label: QUOTATION_WORKFLOW_STATUS_LABEL.manajer_approved },
  { value: 'rejected', label: QUOTATION_WORKFLOW_STATUS_LABEL.rejected },
  { value: 'rejected_by_manajer', label: QUOTATION_WORKFLOW_STATUS_LABEL.rejected_by_manajer },
  { value: 'customer_approved', label: QUOTATION_WORKFLOW_STATUS_LABEL.customer_approved },
  { value: 'need_attention', label: QUOTATION_WORKFLOW_STATUS_LABEL.need_attention },
  { value: 'edit_requested', label: QUOTATION_WORKFLOW_STATUS_LABEL.edit_requested },
  { value: 'sent', label: QUOTATION_WORKFLOW_STATUS_LABEL.sent },
  { value: 'in_progress', label: QUOTATION_WORKFLOW_STATUS_LABEL.in_progress },
  { value: 'completed', label: QUOTATION_WORKFLOW_STATUS_LABEL.completed },
  { value: 'cancelled', label: QUOTATION_WORKFLOW_STATUS_LABEL.cancelled },
  { value: 'paid', label: QUOTATION_WORKFLOW_STATUS_LABEL.paid },
] as const;

export const QUOTATION_RECURRING_TYPE_OPTIONS = [
  { value: 'weekly', label: 'Mingguan' },
  { value: 'monthly', label: 'Bulanan' },
  { value: 'triwulan', label: 'Triwulan' },
  { value: 'yearly', label: 'Tahunan' },
] as const;

export type QuotationRecurringTypeValue = (typeof QUOTATION_RECURRING_TYPE_OPTIONS)[number]['value'];

export const QUOTATION_CONTRACT_PERIOD_TYPE_OPTIONS = [
  { value: 'week', label: 'Minggu' },
  { value: 'month', label: 'Bulan' },
  { value: 'year', label: 'Tahun' },
] as const;

export type QuotationContractPeriodTypeValue =
  (typeof QUOTATION_CONTRACT_PERIOD_TYPE_OPTIONS)[number]['value'];
